<div class="dark:bg-black p-6">
  <h3 class="pb-2 text-primary text-l font-bold">Generate new key pair</h3>
  <p class="text-primary dark:text-white">
    Any existing keys for this gateway will be revoked and
    will no longer work. The newly generated keys have to
    be replaced locally on the gateway for it to stay connected.<br><br>
    <b>There is no UNDO for this action</b>, so do not proceed if you
    are not sure. Do you want to proceed?
  </p>
  <div class="mt-8">
    <button (click)="onYesClick()" class="btn btn-primary mr-4" > Proceed</button>
    <button (click)="onNoClick()" class="btn"> Cancel </button>
  </div>
</div>
